import { request } from '../api';

export const getApiKeys = (action) => {
  const query: any = {};

  const paginationDetails = action.paginationDetails?.paginationDetails || {};

  const page = (isNaN(paginationDetails.page)) ? null : paginationDetails.page;
  const pageSize = (isNaN(paginationDetails.pageSize)) ? null : paginationDetails.pageSize;

  if (page !== null && pageSize !== null) {
    query.page = page;
    query.pageSize = pageSize;
  }

  // Handle sort parameter
  if (paginationDetails?.sort) {
    query.sort = paginationDetails.sort;
  }

  return request(action, {
    payload: {
      url: `/clients/keys`,
      query,
      options: {
        method: 'GET'
      }
    }
  });
};

export const deleteApiKeyById = (action) => {
  return request(action, {
    payload: {
      url: `/clients/keys/${action.keyId}`,
      options: {
        method: 'DELETE',
      },
    }
  });
};

export const createApiKey = (action) => {
  return request(action, {
    payload: {
      url: `/auth/apikey`,
      options: {
        method: 'POST',
        data: {
          roles: action.roles?.join(',') || '',
          name: action.name || null
        }
      }
    }
  });
};

export const updateApiKey = (action) => {
  return request(action, {
    payload: {
      url: `/clients/keys/${action.keyId}`,
      options: {
        method: 'PATCH',
        data: {
          name: action.name || null,
          roles: action.roles?.join(',') || ''
        }
      }
    }
  });
};
